import { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Menu, ChevronDown, LogOut } from "lucide-react";

import { logout } from "../features/auth/authSlice";
import { MENU_GROUPS } from "./menuConfig";

// judul halaman diambil dari struktur menu
const findPage = (pathname) => {
    for (const group of MENU_GROUPS) {
        for (const item of group.items) {
            if (pathname.includes(`/${item.to}`)) {
                return { group: group.title, label: item.label };
            }
        }
    }
    return { group: null, label: "Admin" };
};

export default function Header({ onMenuClick }) {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef();
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const user = useSelector((state) => state.auth?.user);

    const name = user?.name || user?.username || "User";
    const page = findPage(pathname);

    useEffect(() => {
        const handleClick = (e) => {
            if (!dropdownRef.current?.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClick);
        return () => document.removeEventListener("mousedown", handleClick);
    }, []);

    return (
        <header className="h-16 shrink-0 flex items-center justify-between gap-4 bg-white border-b border-line px-4 md:px-6 sticky top-0 z-30 no-print print:hidden">

            <div className="flex items-center gap-3 min-w-0">
                <button
                    type="button"
                    onClick={onMenuClick}
                    className="md:hidden p-2 -ml-2 rounded-md text-muted hover:bg-surface"
                    aria-label="Buka menu"
                >
                    <Menu size={20} />
                </button>

                <div className="min-w-0">
                    {page.group && (
                        <div className="text-xs text-muted leading-none mb-1">{page.group}</div>
                    )}
                    <h1 className="text-base md:text-lg font-semibold text-body leading-none truncate">
                        {page.label}
                    </h1>
                </div>
            </div>

            <div className="relative" ref={dropdownRef}>
                <button
                    type="button"
                    onClick={() => setOpen(!open)}
                    className="flex items-center gap-2 rounded-md pl-1 pr-2 py-1 hover:bg-surface"
                    aria-haspopup="menu"
                    aria-expanded={open}
                >
                    <span className="w-8 h-8 rounded-full bg-ink text-white text-sm font-semibold flex items-center justify-center">
                        {name.charAt(0).toUpperCase()}
                    </span>
                    <span className="hidden sm:block text-sm font-medium text-body max-w-[160px] truncate">
                        {name}
                    </span>
                    <ChevronDown size={16} className="text-muted" />
                </button>

                {open && (
                    <div
                        role="menu"
                        className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-line p-1.5"
                    >
                        <div className="px-3 py-2 border-b border-line mb-1">
                            <div className="text-xs text-muted">Masuk sebagai</div>
                            <div className="text-sm font-semibold text-body truncate">{name}</div>
                        </div>

                        <button
                            type="button"
                            role="menuitem"
                            onClick={() => dispatch(logout())}
                            className="w-full flex items-center gap-2 text-left px-3 py-2 text-sm text-red-600 hover:bg-red-50 rounded-md"
                        >
                            <LogOut size={16} />
                            Keluar
                        </button>
                    </div>
                )}
            </div>
        </header>
    );
}
